import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/find-your-size/lens-width.svg")